import { CONFIG } from "../../lib/appConfig";
import request from "./request"

/**
 * @name recaptchaRequest
 * @desc A function that acts as a wrapper for the original `request` function, adding a reCAPTCHA Enterprise call.
 * It takes the provided `requestConfig` object and enhances it with reCAPTCHA verification.
 * 
 * @param {object} requestConfig - Config object 
 * @param {object} requestConfig.data - The data object containing parameters for the request.
 * @param {object} requestConfig.opts - Options for the request, including the `actionName` to use in reCAPTCHA.
 * 
 * @returns {object|Promise} - Error messages || A new request call
 *
 * @memberof actions
 * 
 * @example
 * dispatch(actions.recaptchaRequest({
 *    service,
 *    data: { payloadObject }, // Object containing params, one of the fields would be the payload. 
 *    opts:{ actionName: 'actionName'} // just to have it clear that it is part of the options
 * }))
 * 
 */
function recaptchaRequest(requestConfig){

  return async dispatch => {
    const { RECAPTCHA_SITE_KEY: siteKey } = CONFIG;
    const { data, opts } = requestConfig;
    
    const token = await window?.grecaptcha?.enterprise.execute(siteKey, {
      action: opts.actionName
    });

    let recaptchaData = {};
    const verification = {
      token: token,
      key: siteKey,
      process: opts.actionName
    };

    if(data?.payload) {
      data.payload = {
        ...data?.payload,
        verification
      };
      recaptchaData = data;
    } else {
      recaptchaData = {
        ...data,
        verification
      };
    }

    return dispatch(request({ ...requestConfig, data: recaptchaData }));
  };
}

export default recaptchaRequest;
